new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
            .then(res => {
                const actualElement = event.target;
                if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                    $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                }
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.remove('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.add('is-selected');
                actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);
                // Marca que a cor foi escolhida pelo cliente (a inicial vem marcada pelo HTML)
                actualElement.closest('.product-item-kit').setAttribute('data-color-selected', 'true');
                actualElement.closest('.product__colors-item').classList.add('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                const itemKit = actualElement.closest('.product-item-kit');
                var sizes = [];
                for (i = 0; i <= res.data.variations.length - 1; i++) {
                    if (res.data.variations[i].main_attribute != null) {
                        sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                    }
                }
                // O container de variações só existe quando o item já tinha tamanhos. Sem ele,
                // nextElementSibling é null (ou o bloco de complementos, que não pode ser
                // sobrescrito), então é preciso validar antes de mexer e criar quando faltar.
                let actualVariations = itemKit.nextElementSibling;
                if (actualVariations && !actualVariations.classList.contains('product-radio-variation')) {
                    actualVariations = null;
                }
                if (!actualVariations && sizes.length) {
                    actualVariations = document.createElement('div');
                    actualVariations.className = 'product-radio-variation radio-content container_general attribute';
                    itemKit.parentNode.insertBefore(actualVariations, itemKit.nextSibling);
                }
                // Produto sem variação (ex.: boné) não pode ficar com o rótulo "Selecione o
                // tamanho" sozinho na tela, nem com o container vazio prendendo a compra
                if (actualVariations) {
                    actualVariations.innerHTML = sizes.length ? '<p class="label_attributes">Selecione o tamanho</p>' : '';
                }
                // Os tamanhos do mesmo item precisam compartilhar o name, mas cada slide
                // precisa de um grupo próprio. Kits com produtos repetidos podem ter o mesmo
                // produto/variação em mais de um slide e não podem compartilhar name nem id.
                const btnAddToCart = document.querySelector('.js-btn__product_detail__add_to_cart');
                const idAuto = btnAddToCart ? btnAddToCart.getAttribute('data-id-auto') : '';
                const slide = itemKit.closest('.itens-for-carousel');
                const slideKey = slide && slide.id ? slide.id.replace(/[^a-zA-Z0-9_-]/g, '') : 'item';
                const groupName = `product_item_variation__product_detail_${idAuto}_${res.data.id}_${slideKey}`;
                for (i = 0; i <= sizes.length - 1; i++) {
                    if (sizes[i].main_attribute != null) {
                        var inputId = `product_item_variation__product_detail_${idAuto}_${sizes[i].id}_${slideKey}`;
                        var stock = sizes[i].available == false ? 'out-of-stock' : '';
                        actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="${groupName}" id="${inputId}" value="${sizes[i].id}" data-id="${sizes[i].id}" data-id-auto="${idAuto}" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="${inputId}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                    }
                }
                if (res.data.addons.length) {
                    var complements = document.createElement('div');
                    complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
                    complements.setAttribute('class', 'complements');
                    complements.setAttribute('complements-for', `${id}`);
                    complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                    for (i = 0; i <= res.data.addons.length - 1; i++) {
                        var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                        var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                        complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                        if (res.data.addons[i].field_type == "radio_options") {
                            var complementsSelect = document.createElement('select');
                            complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                            complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                            for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                            }
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content');
                            $(selectDiv).append(complementsSelect);
                            $(complements).append(selectDiv);
                        } else if (res.data.addons[i].field_type == "text") {
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content-area');
                            $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                            $(complements).append(selectDiv);
                        }
                    }
                    $('.kitcolors').closest('.itens-for-carousel').append(complements);
                }
                $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function() {
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);
                });
                // O estado do botão comprar é calculado no escopo do $(document).ready
                $(document).trigger('kit:item-changed');
                if (window.outerWidth <= 991) {
                    var slickSlider = $('.product-detail__header--photoArea-mobile');

                    if (slickSlider.hasClass('slick-initialized')) {
                        slickSlider.slick('slickRemove', null, null, true);
                    } else {
                        slickSlider.slick();
                    }
                
                    for (i = 0; i < res.data.images.length; i++) {
                        slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-fancybox="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                    }
                
                    slickSlider.slick('slickGoTo', 1);
                } else {
                    const noThumbs = document.querySelector('#product-photo');
                    if (noThumbs) {
                        var noThumbsUl = document.querySelector('#product-photo ul');

                        // Remova todos os spans dentro do noThumbsUl
                        while (noThumbsUl.firstChild) {
                            noThumbsUl.removeChild(noThumbsUl.firstChild);
                        }

                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            var li = document.createElement('li');
                            li.innerHTML = `<a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                            noThumbsUl.appendChild(li);
                        }
                    } else {
                        $('.sp-wrap').each(function() {
                            $(this).closest('.slick-slide').remove();
                        });
                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                            if (i == 0) {
                                document.querySelector('.sp-wrap').click();
                            }
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            let galleryLeft = document.querySelector('.gallery-left');
            let galleryRight = document.querySelector('.gallery-righ');

            if(photoArea && photoThumbs) {
                let photoListItem = document.querySelectorAll('#photo-list li');
                let singlePhotoItem = document.querySelectorAll('#product-photo img');

                if(photoListItem.length && singlePhotoItem.length) {
                    photoListItem[0].classList.add('active');
                    singlePhotoItem[0].classList.add('active');

                    function activeTab(index) {
                        // thumbs de vídeo ficam depois das fotos e abrem na fancybox, sem foto grande correspondente
                        if (!singlePhotoItem[index]) return;
                        singlePhotoItem.forEach((content) => {
                            content.classList.remove('active');
                        });
                        singlePhotoItem[index].classList.add('active');
                    }
    
                    photoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => {
                            activeTab(index);
                        });
                    });
                }
            }

            if (galleryLeft && galleryRight) {
                $('#photo-list').slick({
                    infinite: false,
                    slidesToShow: 5,
                    vertical: true,
                    slidesToScroll: 1
                });
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const isMobile = window.matchMedia("(max-width: 992px)").matches;
            // No mobile a referência é o próprio botão comprar da página; no desktop segue o kit
            const buyButton = (isMobile && document.querySelector(".product-detail__header .product-detail__header--infoArea-buy-section-button"))
                || document.getElementById("kit-variations-div");
            const fixedBuy = document.querySelector(".product-detail__fixed--buy");
            const zoomContainer = document.getElementById("zoom-container");

            if (!buyButton || !fixedBuy) return;

            const rect = buyButton.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            const kitVisible = rect.top < viewportHeight && rect.bottom > 0;
            const kitAboveViewport = rect.bottom <= 0;           // sumiu para cima
            const kitBelowViewport = rect.top >= viewportHeight; // sumiu para baixo

            let zoomVisible = false;
            if (zoomContainer) {
                const zoomRect = zoomContainer.getBoundingClientRect();
                zoomVisible = zoomRect.top < viewportHeight && zoomRect.bottom > 0;
            }

            // Se o zoom estiver visível, nunca mostra o botão flutuante
            if (zoomVisible) {
                fixedBuy.classList.remove("active");
                return;
            }

            // Mobile: mostra sempre que o comprar não estiver na tela (acima ou abaixo)
            if (isMobile) {
                fixedBuy.classList.toggle("active", !kitVisible);
                return;
            }

            // Regras:
            // - Se o kit está visível na tela → esconde botão flutuante
            // - Se o kit sumiu "para baixo" (abaixo do viewport) → esconde botão flutuante
            // - Se o kit sumiu "para cima" (acima do viewport) E zoom não está visível → mostra botão flutuante
            if (kitAboveViewport && !kitVisible && !kitBelowViewport) {
                fixedBuy.classList.add("active");
            } else {
                fixedBuy.classList.remove("active");
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.clickThumbs();
        this.checkBuyView();
        window.addEventListener("scroll", this.checkBuyView, { passive: true });

        document.querySelectorAll('figure.brand[data-image-brand]').forEach(function (figure) {
          var url = figure.getAttribute('data-image-brand');
          figure.innerHTML = '<img src="' + url + '" alt="">';
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });

        const vinculoSimilares = document.querySelector('.vinculo-similares-selector');
        const priceArea = document.querySelector('.product-detail__header--infoArea-price');
        if (vinculoSimilares && priceArea) {
            priceArea.appendChild(vinculoSimilares);
        }
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    let navTab = document.querySelector('.product-detail__nav');
    let nav = document.querySelector('.product-detail__nav-tab');
    let navItem = nav ? nav.querySelectorAll('.nav-item') : [];
    let navContent = document.querySelector('.product-detail__nav-content');
    let navShow = navContent ? navContent.querySelectorAll('.nav-show') : [];

    if (navTab && navItem.length === 0) {
        navTab.style.display = 'none';
    }

    if (navTab && navItem.length && navShow.length) {
        navItem = Array.from(navItem);
        navShow = Array.from(navShow);

      navItem[0].classList.add('active');
      navShow[0].classList.add('active');

        function activeTab(index) {
            navShow.forEach((content) => {
                content.classList.remove('active');
            });
            navItem.forEach((item) => {
                item.classList.remove('active');
            });
            navShow[index].classList.add('active');
            navItem[index].classList.add('active');
        }

        navItem.forEach((itemMenu, index) => {
            itemMenu.addEventListener('click', () => {
                const isActive = itemMenu.classList.contains('active');

                // Se já estiver ativo, desativa
                if (isActive) {
                    itemMenu.classList.remove('active');
                    navShow[index].classList.remove('active');
                } else {
                    activeTab(index);
                }
            });
        });
    }

    const allSizesLabel = document.querySelectorAll('label[for^="product_item_variation__product_detail__');
    if (allSizesLabel) {
        allSizesLabel.forEach(label => {
            label.addEventListener('click', () => {
                const inputId = label.getAttribute('for');
                if (inputId) {
                    const container = document.querySelector('.product-detail__fixed--buy');
                    if (container) {
                        const inputsInContainer = container.querySelectorAll('input.clicou');
                        inputsInContainer.forEach(input => {
                            input.classList.remove('clicou');
                        });
                    }

                    const allInputs = document.querySelectorAll('input.clicou');
                    if (allInputs) {
                        allInputs.forEach(input => {
                            input.classList.remove('clicou');
                        });
                    }

                    const allSameInputs = document.querySelectorAll(`input[id^="${inputId}"]`);

                    if (allSameInputs) {
                        allSameInputs.forEach(input => {
                            input.classList.add('clicou');
                        })
                    }

                }
            });
        })
    }

    const entregaEl = document.querySelector(".prazo-entrega");
    if (!entregaEl) return;

    const daysEl = entregaEl.querySelector(".prazo-entrega-days");
    if (!daysEl) return;

    const leapDaysAttr = entregaEl.dataset.leapDays;
    const prazoEntregaAttr = daysEl.dataset.prazoEntrega;

    if (!leapDaysAttr || !prazoEntregaAttr) return;

    const leapDays = parseInt(leapDaysAttr, 10);
    const prazoEntrega = parseInt(prazoEntregaAttr, 10);

    if (isNaN(leapDays) || isNaN(prazoEntrega)) return;

    const hoje = new Date();

    // Função para adicionar dias úteis (ignora sábados e domingos)
    function adicionarDiasUteis(data, dias) {
      const novaData = new Date(data);
      let adicionados = 0;

      while (adicionados < dias) {
        novaData.setDate(novaData.getDate() + 1);
        const diaSemana = novaData.getDay();
        if (diaSemana !== 0 && diaSemana !== 6) {
          adicionados++;
        }
      }

      return novaData;
    }

    // Pula se a data final cair num sábado ou domingo
    function pularFimDeSemana(data) {
      const novaData = new Date(data);
      const diaSemana = novaData.getDay();
      if (diaSemana === 6) {
        novaData.setDate(novaData.getDate() + 2); // sábado → segunda
      } else if (diaSemana === 0) {
        novaData.setDate(novaData.getDate() + 1); // domingo → segunda
      }
      return novaData;
    }

    // Meses abreviados
    const mesesAbreviados = [
      "jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
      "jul.", "ago.", "set.", "out.", "nov.", "dez."
    ];

    function formatarData(data) {
      const dia = data.getDate();
      const mes = mesesAbreviados[data.getMonth()];
      return `<b>${dia} de ${mes}</b>`;
    }

    // Calcula datas ignorando finais de semana
    const dataInicio = adicionarDiasUteis(hoje, leapDays);
    const dataFimRaw = adicionarDiasUteis(dataInicio, prazoEntrega);
    const dataFim = pularFimDeSemana(dataFimRaw);

    // Insere no HTML
    daysEl.innerHTML = `${formatarData(dataInicio)} e ${formatarData(dataFim)}`;

    waitForElementToExist('#js-product_attributes__product_detail_ .atributes').then(element => { 
        $('#carrousel-atributes').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 700,
        });
    })

    const productColors = document.querySelector('.product__colors.attribute');
    const itemsPerBatch = 500;
  
    if (productColors) {
      const children = Array.from(productColors.children);
  
      if (children.length > itemsPerBatch) {
        // Ocultar os itens extras
        children.slice(itemsPerBatch).forEach(child => {
          child.style.display = 'none';
        });
  
        // Criar o botão "Ver mais"
        const showMoreButton = document.createElement('button');
        showMoreButton.textContent = 'Ver mais';
        showMoreButton.className = 'btn-show-more';
        productColors.appendChild(showMoreButton);
  
        // Evento para mostrar mais itens
        showMoreButton.addEventListener('click', () => {
          const hiddenItems = children.filter(child => child.style.display === 'none');
          const nextBatch = hiddenItems.slice(0, itemsPerBatch);
  
          nextBatch.forEach(item => {
            item.style.display = '';
          });
  
          // Remover botão se não houver mais itens ocultos
          if (hiddenItems.length <= itemsPerBatch) {
            showMoreButton.remove();
          }
        });
      }
    }

    $("body").on("click", '.minus', function(event) {
        event.preventDefault();
        var $input = $(this).closest('.amount').find('.quantidade');
        var qtd = parseInt($input.val(), 10);
    
        if (qtd > 1) {
            qtd--;
            $input.val(qtd).attr('value', qtd);
        }
    });
    
    $("body").on("click", '.plus', function(event) {
        event.preventDefault();
        var $input = $(this).closest('.amount').find('.quantidade');
        var qtd = parseInt($input.val(), 10);
    
        qtd++;
        $input.val(qtd).attr('value', qtd);
    });

    // Todos os widgets de variação (select, radio e cor/imagem) usam este prefixo de name
    const KIT_VARIATION_SELECTOR = '[name^="product_item_variation__product_detail_"]';

    function getKitVariationInputs(slide) {
        return Array.from(slide.querySelectorAll(KIT_VARIATION_SELECTOR)).filter(input => {
            return input.tagName === 'SELECT' || input.type === 'radio';
        });
    }

    // Somente itens marcados como sem variação (ex.: boné) exigem que o cliente
    // clique numa cor. A cor inicial já vem marcada no HTML, então só vale a
    // escolha explícita registrada pelo getInfo em data-color-selected.
    function kitSlideNeedsColor(slide) {
        const itemKit = slide.querySelector('.js_product_item_kit');
        const hasColors = Boolean(slide.querySelector('.kitcolors .product__colors-item'));
        const hasNoVariations = Boolean(itemKit && itemKit.getAttribute('data-no-variations'));

        if (!hasNoVariations || !hasColors) {
            return false;
        }

        return !itemKit.getAttribute('data-color-selected');
    }

    // Item do kit resolvido: não exige escolha ou o cliente já escolheu em todos os grupos de variação
    function isKitSlideReady(slide) {
        if (kitSlideNeedsColor(slide)) {
            return false;
        }

        const itemKit = slide.querySelector('.js_product_item_kit');

        if (itemKit && itemKit.getAttribute('data-no-variations')) {
            return true;
        }

        const inputs = getKitVariationInputs(slide);

        if (!inputs.length) {
            return true;
        }

        // Basta uma escolha: o widget do kit renderiza um único atributo (o principal),
        // e não dá para exigir "um selecionado por name" porque o HTML recriado na troca
        // de cor pode vir com um name diferente por rádio.
        return inputs.some(input => {
            return input.tagName === 'SELECT' ? Boolean(input.value) : input.checked;
        });
    }

    // Função para verificar se todos os itens do kit têm tamanhos selecionados
    function checkAllKitItemsHaveSizes() {
        const slides = Array.from(document.querySelectorAll('.itens-for-carousel'));

        // Se não há itens do kit, considera como válido
        return slides.every(isKitSlideReady);
    }

    // Função para atualizar o estado do botão de compra
    function updateAddToCartButtonState() {
        const addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
        if (addToCartButtons.length > 0) {
            const allItemsHaveSizes = checkAllKitItemsHaveSizes();

            if (allItemsHaveSizes) {
                addToCartButtons.forEach(button => {
                    button.classList.remove('no-buy');
                });
            } else {
                addToCartButtons.forEach(button => {
                    button.classList.add('no-buy');
                });
            }
        }
    }

    // Listener para quando uma variação é selecionada. Delegado e sem depender de
    // radio, porque os itens são recriados ao trocar de cor (produtos vinculados)
    // e o widget pode ser select em vez de radio.
    $(document).on('change', '.carousel-kit ' + KIT_VARIATION_SELECTOR, function() {
        updateAddToCartButtonState();
    });

    $(document).on('click', '.carousel-kit', function() {
        window.setTimeout(updateAddToCartButtonState, 0);
    });

    // Disparado pelo getInfo depois de trocar o produto vinculado (cor) do item
    $(document).on('kit:item-changed', function() {
        updateAddToCartButtonState();
    });

    updateAddToCartButtonState();

    waitForElementToExist('.product__colors.attribute').then(element => {
        $('.product__colors.attribute').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 5,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 7,
                        variableWidth: true,
                    }
                },
            ]
        });
    });
    

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
            768: {
                drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            // Kit sem variação nenhuma já nasce liberado para comprar
            updateAddToCartButtonState();

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));
                    
                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });
        
        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');

                if (!activeSlide || isKitSlideReady(activeSlide)) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.innerHTML = kitSlideNeedsColor(activeSlide)
                        ? '<i></i> Selecione a cor para continuar'
                        : '<i></i> Selecione uma opção para continuar';
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
            updateAddToCartButtonState();
        });
    }

    // Tags da foto aparecem só na primeira imagem do slider mobile
    $('.product-detail__header--photoArea-mobile').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(this).closest('.product-detail__header--photoArea').toggleClass('not-first-slide', nextSlide !== 0);
    });

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        prevArrow: $(".product-list-arrows .prev"),
        nextArrow: $(".product-list-arrows .next"),
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('#photo-fancy').fancybox();
});
